import type { FaireProductEntity } from "../../entity_types/product";

export const p_9cmx5brs8d: FaireProductEntity = {
  token: "p_9cmx5brs8d",
  type: "product",
  name: "Ultimate Mineral Guide 100% HW Cotton Adult T-shirt",
  brandToken: "b_ihxgqwki5y",
  brandName: "Atlas Screen Printing",
  imageUrl:
    "https://cdn.faire.com/fastly/f5f078f2358436b5b8786cdb88c5b571a86f029b24418bd25157db433204a08e.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.86,
  description:
    "This WILD COTTON® 100% HW Cotton Adult T-shirt is decorated with our original screen printed art is comfortable to wear, safe to wash and will last for years.",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:01.600Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
